import { supabase } from "@/api/supabaseClient";
import { recoveryRedirectUrl } from "@/auth/linking";
import { allowNextSignedIn, cancelExplicitSignIn } from "@/auth/webSignOutLatch";

export async function signIn(email: string, password: string) {
  allowNextSignedIn();
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) throw error;
    return data;
  } catch (err: unknown) {
    cancelExplicitSignIn();
    throw err;
  }
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export async function resetPassword(email: string) {
  // Redirect muss in der Supabase-Allowlist stehen.
  // Das Recovery-Template hängt token_hash an diese URL; die App löst ihn erst per Button ein.
  const { data, error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
    redirectTo: recoveryRedirectUrl(),
  });
  if (error) throw error;
  return data;
}
